import dva from 'dva'
import { createHashHistory } from 'history'

export const history = createHashHistory()

const app = dva({ history })

export default app